import { Link } from 'react-router-dom';
import './VratLinks.scss'; // You will create this SCSS file

const vratLinks = [
  { title: "Sankashti Chaturthi", path: "/vrat/sankashti-chaturthi" },
  { title: "Ekadashi", path: "/vrat/ekadashi" },
  { title: "Purnima Dates", path: "/vrat/purnima-dates" },
  { title: "Amavasya Dates", path: "/vrat/amavasya-dates" },
  { title: "Vinayaka Chaturthi", path: "/vrat/vinayaka-chaturthi" },
  { title: "Chandra Darshan", path: "/vrat/chandra-darshan" },
  { title: "Pradosham Dates", path: "/vrat/pradosham-dates" },
  { title: "Sankranti Dates", path: "/vrat/sankranti-dates" },
  { title: "Satyanarayana Puja", path: "/vrat/satyanarayana-puja" },
  { title: "Masik Shivaratri", path: "/vrat/masik-shivaratri" },
  { title: "Masik Durgaashtami", path: "/vrat/masik-durgaashtami" },
  { title: "Masik Kalashtami", path: "/vrat/masik-kalashtami" },
  { title: "Krathigai Dates", path: "/vrat/krathigai-dates" },
  { title: "Shraddha Dates", path: "/vrat/shraddha-dates" },
  { title: "Janmashtami Dates", path: "/vrat/janmashtami-dates" },
  { title: "Skanda Sashthi", path: "/vrat/skanda-sashthi" },
  { title: "Iskon Ekadashi", path: "/vrat/iskon-ekadashi" },
  { title: "Vrat Kotha", path: "/vrat/vrat-katha" },
];

const VratLinks = () => {
  return (
    <div className="vrat-link-container">
      <h2 className="vrat-link-title">Vrat & Upavas</h2>
      <div className="vrat-link-grid">
        {vratLinks.map((item, index) => (
          <Link key={index} to={item.path} className="vrat-link-item">
            <img
              src="https://staticimg.amarujala.com/assets/images/2025/05/12/vat-savitri-vrat-2025_cc1c8c13c4432e42e32bc7afc590c592.jpeg?q=80&w=480&dpr=2.6"
              alt={item.title}
            />
            {item.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default VratLinks;
